import { useTransactionsStore } from '../stores/transactions-store'
import { type PaginationState, type SortingState } from '@tanstack/react-table'

export const useTransactionsActions = () => {
  const setPage = useTransactionsStore((state) => state.pagination.setPage)
  const setLimit = useTransactionsStore((state) => state.pagination.setLimit)
  const setSorting = useTransactionsStore((state) => state.sorting.setSorting)

  return {
    setPage,
    setLimit,
    setSorting,
    setOpen: useTransactionsStore((state) => state.dialog.setOpen),
    onPaginationChange: (pagination: PaginationState) => {
        setPage(pagination.pageIndex + 1)
        setLimit(pagination.pageSize)
    },
    onSortingChange: (sorting: SortingState) => {
        setSorting(sorting)
    }
  }
}
